import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BrandLogoComponent } from '@bodyanalytics/ui-core';

/**
 * MemberLoginPanel — the single, shared "member access" login card.
 *
 * Extracted (#1929) so the Calendar and Customer portals render an identical
 * login look, feel, and content. Previously the Login page branched per portal
 * — Calendar showed a single-column booking-funnel variant while Customer showed
 * this two-column member card — which QA flagged as inconsistent. The founder
 * decision converged both portals on the polished Customer look; this presentational
 * component is that shared surface.
 *
 * Purely presentational: no auth/session state, no routing decisions. The smart
 * container owns Auth0 (per-app client config + redirects) and reacts to the
 * `login` output. The container passes the resolved theme via `isDark` so the
 * brand lockup stays legible on the card (white wordmark on ocean in dark mode,
 * navy wordmark on white in light mode).
 */
@Component({
  selector: 'bodyanalytics-member-login-panel',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './member-login-panel.component.html',
  styleUrls: ['./member-login-panel.component.scss'],
  imports: [RouterLink, BrandLogoComponent],
})
export class MemberLoginPanelComponent {
  /** Resolved theme, forwarded to the brand lockup variant. */
  readonly isDark = input(false);

  /** Emitted when the member triggers the Auth0 "Log in / Sign up" CTA. */
  readonly login = output<void>();
}
